/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    a: "a",
    div: "div",
    p: "p",
    strong: "strong",
    ul: "ul",
    li: "li",
    img: "img",
    h2: "h2",
    pre: "pre",
    code: "code"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, {
    id: "p5jacdac",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#p5jacdac",
    "aria-label": "p5jacdac permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "p5.jacdac"), "\n", React.createElement(_components.p, null, React.createElement(_components.strong, null, "p5.jacdac"), " integrates Jacdac with ", React.createElement(_components.a, {
    href: "https://p5js.org",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "p5*js"), " to create creative coding with physical devices\nwith installing any drivers!"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "no driver or installation needed"), "\n", React.createElement(_components.li, null, "just works from your browser"), "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "https://editor.p5js.org/pelikhan/sketches/ad1hCFqFF",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "Try it in the p5js editor!")), "\n"), "\n", React.createElement(_components.p, null, React.createElement(_components.img, {
    src: "/jacdac-docs/static/sliders-e8cd630e5b69c64fa2a421296e423135.gif",
    alt: "A program using slider to control the background color"
  })), "\n", React.createElement(_components.h2, {
    id: "usage",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#usage",
    "aria-label": "usage permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Usage"), "\n", React.createElement(_components.p, null, "Use the online version (recommended) and add it to the head section of your HTML document."), "\n", React.createElement(_components.pre, null, React.createElement(_components.code, {
    className: "language-html"
  }, "<script src=\"https://unpkg.com/jacdac-ts/dist/p5.jacdac.js\"></script>\n")), "\n", React.createElement(_components.p, null, "or download the ", React.createElement(_components.a, {
    href: "https://unpkg.com/jacdac-ts/dist/p5.jacdac.js",
    target: "_blank",
    rel: "nofollow noopener noreferrer"
  }, "p5.jacdac.js"), " locally"), "\n", React.createElement(_components.pre, null, React.createElement(_components.code, {
    className: "language-html"
  }, "<script src=\"./p5.jacdac.js\"></script>\n")), "\n", React.createElement(_components.pre, null, React.createElement(_components.code, {
    className: "language-p5js"
  }, "<html>\n  <head>\n    <script src=\"https://unpkg.com/p5@1.4.0/lib/p5.js\"></script>\n    <script src=\"https://unpkg.com/jacdac-ts/dist/p5.jacdac.js\"></script>\n    <script src=\"sketch.js\"></script>\n  </head>\n  <body>\n    <main>\n    </main>\n  </body>\n</html>\n-----\nfunction setup() {\n    createCanvas(400, 400)\n}\nfunction draw() {\n    const { potentiometer } = jacdac.sensors\n    const [r = 0, g = 0, b = 0] = potentiometer\n    background(r * 255, g * 255, b * 255)\n}\n")), "\n", React.createElement(_components.p, null, "That's it! ", React.createElement(_components.code, null, "p5.jacdac"), " will automatically show a button to connect to your\ndevice and hide it when connected."), "\n", React.createElement(_components.h2, {
    id: "whats-next",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#whats-next",
    "aria-label": "whats next permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "What's next?"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "/jacdac-docs/clients/javascript/p5js/sensors"
  }, "sensors"), ", use sensor data in your sketches"), "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "/jacdac-docs/clients/javascript/p5js/events"
  }, "events"), ", register handlers for events"), "\n"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
